import { ErrorInterface } from "anatoliapps-angular/utils";

//#region API Error
/**
 * Component error structure. This extends Error.
 */
export class APIError extends Error implements ErrorInterface {
  /**
   * API error extended class.
   * 
   * @param code - API error code.
   * @param message - The default API error message.
   */
  constructor(public readonly code: string, message?: string) {
    super(APIErrorMessages[code as keyof typeof APIErrorMessages] || message || 'An unknown API error occurred.');

    /* tslint:disable:max-line-length */
    // Set the prototype explicitly. See the following link for more details:
    // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    /* tslint:enable:max-line-length */
    Object.setPrototypeOf(this, APIError.prototype);
  }
}

export const APIErrorMessages = {
  //#region Auth Errors
  'auth/exiting-email': 'Bu email adresi ile daha önce kayıt olunmuş.',
  //#endregion

  //#region Subscription Errors
  'subscription/exiting-email': 'Bu email adresi ile daha önce abone olunmuş.',
  'subscription/invalid-email': 'Geçersiz email adresi.',
  'subscription/missing-email': 'Lütfen email adresinizi giriniz.',
  //#endregion

  //#region Volunteer Errors
  'volunteer/invalid-name': 'Geçersiz isim.',
  'volunteer/missing-name': 'Lütfen isminizi giriniz.',

  'volunteer/invalid-surname': 'Geçersiz soyisim.',
  'volunteer/missing-surname': 'Lütfen soyisminizi giriniz.',

  'volunteer/applied-email': 'Daha önce üyelik başvurunuzu aldık ve en kısa sürede sizinle iletişime geçeceğiz. İlginiz ve sabrınız için teşekkür ederiz!',
  'volunteer/invalid-email': 'Geçersiz email adresi.',
  'volunteer/missing-email': 'Lütfen email adresinizi giriniz.',
  //#endregion
} as const;
//#endregion

//#region Component Error
/**
 * Component error structure. This extends Error.
 */
export class ComponentError extends Error implements ErrorInterface {
  /**
   * Component error extended class.
   * 
   * @param code - Component error code.
   * @param message - The default API error message.
   */
  constructor(public readonly code: string, message?: string) {
    super(ComponentErrorMessages[code as keyof typeof ComponentErrorMessages] || message || 'An unknown component error occurred.');

    /* tslint:disable:max-line-length */
    // Set the prototype explicitly. See the following link for more details:
    // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    /* tslint:enable:max-line-length */
    Object.setPrototypeOf(this, ComponentError.prototype);
  }

  //#region Error Instances
  /** The error instance for if component busy. */
  public static get BUSY() { return new ComponentError(ComponentErrorCode.BUSY); }

  /** The error instance for if component process is completed before. */
  public static get COMPLETED() { return new ComponentError(ComponentErrorCode.COMPLETED); }
  //#endregion
}

/**
 * Component error codes.
 */
export const enum ComponentErrorCode {
  BUSY = 'busy',
  COMPLETED = 'completed'
};

/**
 * Component error messages of error codes.
 */
export const ComponentErrorMessages = {
  [ComponentErrorCode.BUSY]: 'It is not available for this process now.',
  [ComponentErrorCode.COMPLETED]: 'The process is completed before.'
} as const;
//#endregion
